import axios from "axios";
import LocalStorage from "../../localStorage";
import {loggedOut} from "../auth";

export const GET_DRESS_ORIGIN_REQUEST = 'GET_DRESS_ORIGIN_REQUEST';
export const GET_DRESS_ORIGIN_SUCCESS = 'GET_DRESS_ORIGIN_SUCCESS';
export const GET_DRESS_ORIGIN_FAILURE = 'GET_DRESS_ORIGIN_FAILURE';

const localStorageService = LocalStorage.getService();

export const getDressOriginRequest = () => {
    return {type: GET_DRESS_ORIGIN_REQUEST}
};

export const getDressOriginSuccess = (dress_origin = {}) => {
    return {type: GET_DRESS_ORIGIN_SUCCESS, dress_origin}
};

export const getDressOriginFailure = (error) => {
    return {type: GET_DRESS_ORIGIN_FAILURE, error}
};

export const startGetDressOrigin = () => {
    console.log('Start startGetDressOrigin');
    let token = localStorageService.getAccessToken();
    return (dispatch) => {
        dispatch(getDressOriginRequest());
        return axios({
                url: `${process.env.REACT_APP_API_ROOTURL}/dress_origin/list?key=${process.env.REACT_APP_SERVICE_ACCOUNT_KEY}`,
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Access-Control-Allow-Headers': '*',
                    Authorization: 'Bearer ' + token,
                },
                data: JSON.stringify({}),
            }
        )
            .then(function (response) {
                if (response.status === 200 && response.data !== null) {
                    console.log("Response dress_origin search ", response.data);
                    dispatch(getDressOriginSuccess(response.data));

                }
            })
            .catch(function (error) {
                console.log(error);
                if(error.response.status === 401) dispatch(loggedOut());
                dispatch(getDressOriginFailure(error));
            });
    };
};
